const KeenSlider = window.KeenSlider

const { setInitialised, useCounter, useProgress } = window.BAO.Carousel.plugins

class MahinaPreview extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.overlay.element,
      'click',
      this.closeOverlay.bind(this),
    )

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.addOverlay.bind(this),
    )
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.2,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 16,
            },
          },
        },
      },
      [
        setInitialised(),
        useCounter({
          counter: this.els?.counter?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }

  closeOverlay (e) {
    e.preventDefault()

    this.els.overlay.element.classList.add('mhn-Preview_Overlay-hidden')
    this.els.overlay.element.classList.remove('mhn-Preview_Overlay-visible')
    this.els.slides.element.classList.toggle('mhn-Preview_Items-visible')
  }

  addOverlay (e) {
    e.preventDefault()

    this.els.overlay.element.classList.add('mhn-Preview_Overlay-visible')
    this.els.overlay.element.classList.remove('mhn-Preview_Overlay-hidden')
    this.els.slides.element.classList.toggle('mhn-Preview_Items-visible')
  }
}

if (!customElements.get('mahina-preview')) {
  customElements.define('mahina-preview', MahinaPreview)
}
